<template>
  <div class="or-footer">
        <div class="contacts">
            <div class="layout-1200 flex-row row-space-between padding-top-50">
                <div class="contacts-info">
                    <p class="title">КОНТАКТЫ</p>
                    <p class="text">E-mail: {{info ? info.email : null}}</p>
                    <p class="text">Телефон: {{info ? info.phone : null}}</p>
                    <p class="text">Директор: {{info ? info.director : null}}</p>
                </div>
                <div class="contacts-adress">
                    <p class="title">АДРЕС</p>
                    <div v-html="text" class="text"></div>
                </div>
                <div class="contacts-copyright">
                    <p class="title">Сайт разработан Allpackin studio</p>
                    <p class="text">2020 © Все права защищены</p>
                </div>
            </div>
        </div>
        <or-header @toFeedback="toFeedback" class="or-footer-last"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import orHeader from './or-header.vue'
export default {
    components: {orHeader},
    computed: {
        ...mapGetters({info: 'getInfo'}),
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.info.adress, container: div});
            return div.innerHTML;
        }
    },
    // mounted() {
    //     this.convertText({text: this.info.adress, container: this.$refs.adress})
    // },
    methods: {
        ...mapActions({convertText: 'convertText'}),
        toFeedback(data) {
            this.$emit('toFeedback', data);
        }
    }
}
</script>

<style scoped>
    .or-footer {
        background-color: #000000;
        height: 396px;
        width: 100vw;
        min-width: 1200px;
        /* max-width: 100%; */
        position: relative;
        font-size: 14px;
    }
    .contacts {
        position: relative;
        height: 231px;
    }
    .contacts-info {
        text-align: left;
    }
    .contacts-adress {
        text-align: left;
    }
    .contacts-copyright {
        text-align: right;
    }
    .title {
        margin-bottom: 34px;
    }
</style>